<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
html, body {
  height: 100%;
}

body {
  padding: 0px;
  margin: 0px auto;
}

a {
  text-decoration: none;
}

#app {
  height: 100%;
  overflow: hidden;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

.body {
  height: 100%;
  background: #f5f5f5;
  padding: 0px 15px;
  /*border-radius: 8px;*/
  overflow-y: auto;
}

.body-title {
  line-height: 50px;
  margin-bottom: 30px;
  position: relative;
}

.body-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  background: #99999920;
  height: 2px;
  width: 100%;
}

.bg-color {
  background: #f5f5f5;
}

.bg-white {
  background: white;
}

.color-blue {
  color: #409eff;
}

.color-red {
  color: red;
}

/* flex布局 */
.f {
  display: flex;
}

.f1 {
  flex: 1;
}

.f-c {
  display: flex;
  justify-content: center;
}

.f-b {
  display: flex;
  justify-content: space-between;
}

.f-b-c {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.f-a {
  display: flex;
  justify-content: space-around;
}

.f-a-c {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.f--c {
  display: flex;
  align-items: center;
}

.f-c-c {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fw-n {
  flex-wrap: nowrap;
}

.fw-w {
  flex-wrap: wrap;
}

.fd-c {
  flex-direction: column;
}

/* 单行文本超出省略号 */
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 多行文本超出省略号 */
.ellipsis2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.mb10 {
  margin-bottom: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

.mr10 {
  margin-right: 10px;
}

.mr20 {
  margin-right: 20px;
}

.mr30 {
  margin-right: 30px;
}

.pr10 {
  padding-right: 10px;
}

.pr20 {
  padding-right: 20px;
}

.pr30 {
  padding-right: 30px;
}

.p10 {
  padding: 10px;
}

.p20 {
  padding: 20px;
}

.p30 {
  padding: 30px;
}

.pb50 {
  padding-bottom: 50px;
}


/*解决 element ui drawer组件不显示下拉条bug*/
.el-drawer__body {
  overflow: auto;
  /* overflow-x: auto; */
}


.el-table .cell.el-tooltip {
  white-space: nowrap !important;
  min-width: 50px;
}


.operationControl {
  border-bottom: 1px solid #f5f5f6;
  margin-bottom: 2px;
}


.el-popover {
  z-index: 30000 !important;
}

.el-image-viewer__close {
  background: #FFFFFF !important;
  color: #000000 !important;
}
.dx-el-select{
  display: none;
}
// .el-form-item__content{
//   line-height: 20px;
// }
.vue-treeselect__multi-value-item{
  background-color: #f4f4f5;

}
.vue-treeselect__value-remove{
  color: #909399;
}
.vue-treeselect__multi-value-item{
  color: #909399;
}
.zdiconfont {
  font-size: 22px;
}
/* fixed 作业证打印的table 显示不全 */
#printerArea{
  display: block !important;
  & table{
    margin: 0 auto;
  }
}
 textarea::-webkit-input-placeholder {
    font-size: 14px;
    font-family:''
  }
</style>



// WEBPACK FOOTER //
// src/App.vue